import React, { useEffect, useMemo, useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import BillingService from '../../../services/billing/BillingService'
import { getCurrentDateTimeFormatted, getCurrentDateTimeFormattedOnly, getCurrentDateTimeFormattedPlusNDays } from '../../../utilities/Utils'
import DataTable from 'react-data-table-component'
import SweetAlert from 'react-bootstrap-sweetalert'

const ModalAddBilling = ({ showAddBilling, handleCloseShowAddBilling, dataPnbp, reloadList }) => {

    let billingService = useMemo(() => new BillingService(), [])

    const handleClickBatal = () => {
        setDateBill(null)
        setDateBillExpired(null)
        setKodeSatker('')
        setNpwp('')
        setNmWjbByr('')
        // setNoBilling('')
        setKdUpt('')
        reloadList(0, 10, null, nmWjbByr)
        handleCloseShowAddBilling()
    }

    const columns = [
        {
            name: 'Nomor Aju',
            cell: row => row['nomorAju'],
        },
        {
            name: 'Nomor PNBP',
            cell: row => row['noPnbp'],
        },
    ]

    useEffect(() => {
        if (!dataPnbp) return
        const fetchFirstData = async () => {
            try {
                const resSatker = await billingService.getSatkerByKdUpt(dataPnbp[0].kodeUpt)
                // console.log(resSatker)
                setKodeSatker(resSatker.data.kdSatker)

                setKdUpt(dataPnbp[0].kodeUpt)
                setNpwp(dataPnbp[0].npwpTrader)
                setNmWjbByr(dataPnbp[0].namaTrader)
                setDateBill(getCurrentDateTimeFormatted())
                setDateBillExpired(getCurrentDateTimeFormattedPlusNDays(3))
            } catch (error) {
                console.log(error)
            }
        }
        fetchFirstData()
    }, [billingService, dataPnbp])

    const [dateBill, setDateBill] = useState(null)
    const [dateBillExpired, setDateBillExpired] = useState(null)
    const [kodeSatker, setKodeSatker] = useState(null)
    const [npwp, setNpwp] = useState(null)
    const [nmWjbByr, setNmWjbByr] = useState(null)
    // const [noBilling, setNoBilling] = useState(null)
    const [kdUpt, setKdUpt] = useState(null)
    const [isBillingManual, setIsBillingManual] = useState(false)

    // const onChangeNoBilling = e => {
    //     setNoBilling(e.target.value)
    // }

    // const onChangeCheckbox = e => {
    //     e.target.checked ? setIsBillingManual(true) : setIsBillingManual(false)
    // }

    const [showConfirmCreateBill, setShowConfirmCreateBill] = useState(false)
    const handleCloseConfirmCreateBill = () => setShowConfirmCreateBill(false)
    const [loadingCreate, setLoadingCreate] = useState(false)
    const [createBillSuccess, setCreateBillSuccess] = useState(false)
    const [createBillFailed, setCreateBillFailed] = useState(false)
    const [isiPesan, setIsiPesan] = useState(null)

    const handleClickCreateBill = () => {
        setShowConfirmCreateBill(true)
    }

    const handleCreate = async () => {
        setLoadingCreate(true)
        try {
            let billDtl = []
            dataPnbp.map((dtl, index) => {
                let bill = {
                    "nomorAju": dtl.nomorAju,
                    "noPnbp": dtl.noPnbp
                }
                billDtl.push(bill)
                return null
            })
            let randomDigits = String(Math.floor(Math.random() * 90000) + 10000)
            let trxIdKL = 'kkp04-' + kodeSatker + '-' + getCurrentDateTimeFormattedOnly() + randomDigits
            let jsonBill = {
                "trx_id_kl": trxIdKL,
                "date_bill": dateBill,
                "expired_date": dateBillExpired,
                "kode_satker": kodeSatker,
                "nama_wajib_bayar": nmWjbByr,
                "kode_satker_pemungut": kodeSatker,
                "npwp": npwp,
                "kdUpt": kdUpt,
                "data": billDtl
            }
            // console.log(JSON.stringify(jsonBill, null, 2))
            const resp = await billingService.createBilling(jsonBill)
            console.log(resp)
            if (resp.data.status === 'success') {
                setShowConfirmCreateBill(false)
                setCreateBillSuccess(true)
            } else {
                setShowConfirmCreateBill(false)
                setCreateBillFailed(true)
            }
        } catch (error) {
            setIsiPesan(error.response.data.message)
            setShowConfirmCreateBill(false)
            setCreateBillFailed(true)
            // console.log(error.response)
        }
        setLoadingCreate(false)
    }

    const handleClickCreateSuccess = () => {
        setCreateBillSuccess(false)
        handleCloseShowAddBilling()
        reloadList(0, 10, null, nmWjbByr)
    }

    const handleClickCreateFailed = () => {
        setIsiPesan('')
        setCreateBillFailed(false)
        handleCloseShowAddBilling()
        reloadList(0, 10, null, nmWjbByr)
    }

    return (
        <>
            <Modal
                show={showAddBilling}
                onHide={handleCloseShowAddBilling}
                size='xl'
                centered
                backdrop='static'
            >
                <Modal.Header>
                    <Modal.Title><h6>Buat Billing Simponi</h6></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* <div className='row mb-3'>
                        <label className="col-sm-2 col-form-label-sm">Nomor Billing</label>
                        <div className="col-sm-4">
                            <input type="text" className="col-sm-12 form-control-sm" name="noBilling" value={noBilling} disabled={!isBillingManual} onChange={onChangeNoBilling} />
                        </div>
                        <div className='col-sm-4'>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" onChange={onChangeCheckbox} />
                                <label class="form-check-label" for="flexCheckDefault">
                                    Billing Manual
                                </label>
                            </div>
                        </div>
                    </div> */}
                    <div className='row mb-3'>
                        <label className="col-sm-2 col-form-label-sm">NPWP Wajib Bayar</label>
                        <div className="col-sm-4">
                            <input type="text" className="col-sm-12 form-control-sm" name="npwp" value={npwp} disabled />
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <label className="col-sm-2 col-form-label-sm">Nama Wajib Bayar</label>
                        <div className="col-sm-4">
                            <input type="text" className="col-sm-12 form-control-sm" name="nmWjbByr" value={nmWjbByr} disabled />
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <label className="col-sm-2 col-form-label-sm">Tanggal Billing</label>
                        <div className="col-sm-4">
                            <input type="text" className="col-sm-12 form-control-sm" name="tglBilling" value={dateBill} disabled />
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <label className="col-sm-2 col-form-label-sm">Tanggal Expired</label>
                        <div className="col-sm-4">
                            <input type="text" className="col-sm-12 form-control-sm" name="tglExpired" value={dateBillExpired} disabled />
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <label className="col-sm-2 col-form-label-sm">Kode UPT</label>
                        <div className="col-sm-4">
                            <input type="text" className="col-sm-12 form-control-sm" name="kodeUpt" value={kdUpt} disabled />
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <label className="col-sm-2 col-form-label-sm">Kode Satker</label>
                        <div className="col-sm-4">
                            <input type="text" className="col-sm-12 form-control-sm" name="kodeSatker" value={kodeSatker} disabled />
                        </div>
                    </div>
                    {
                        dataPnbp &&
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#7c878dff', 'color': 'white' } } }}
                            columns={columns}
                            data={dataPnbp}
                            highlightOnHover
                            pagination
                        />
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => handleClickCreateBill()}>
                        Buat Billing
                    </Button>
                    <Button variant="danger" size="sm" onClick={() => handleClickBatal()}>
                        Kembali
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmCreateBill &&
                <SweetAlert
                    title="Buat Billing?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingCreate ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Create...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleCreate}
                    onCancel={handleCloseConfirmCreateBill}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingCreate}
                >
                    {loadingCreate && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Buat Billing, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                createBillSuccess &&
                <SweetAlert
                    success
                    title="Buat Billing Berhasil"
                    onConfirm={handleClickCreateSuccess}
                    btnSize="sm"
                />
            }
            {
                createBillFailed &&
                <SweetAlert
                    danger
                    title="Buat Billing Gagal"
                    onConfirm={handleClickCreateFailed}
                    btnSize="sm"
                >{isiPesan}</SweetAlert>
            }
        </>
    )
}

export default ModalAddBilling